import React, { useEffect, useState } from "react";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import { StyledFeeWrapper } from "../../../fee/styledFee";
import MaterialPagination from "../../../styles/materialPagination";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import axios from "axios";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { useHistory } from "react-router-dom";
import Notification from "../../../elements/notification/Notification";
import FeeList from "./FeeList";
import FeeFilter from "./FeeFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import { parseAxiosError } from "../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";

const FeeContainer = ({ match }) => {
  const [fees, setFees] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "fee", false, true),
    "baseFee.service.name": checkFilterItem(history, "baseFee.service.name", null),
    "baseFee.paymentSystem.name": checkFilterItem(history, "baseFee.paymentSystem.name", null),
    "baseFee.currency.asset": checkFilterItem(history, "baseFee.currency.asset", null),
    "baseFee.type": checkFilterItem(history, "baseFee.type", null),
    "percent[gte]": checkFilterItem(history, "percent[gte]", null, true),
    "percent[lte]": checkFilterItem(history, "percent[lte]", null, true),
    "constant[gte]": checkFilterItem(history, "constant[gte]", null, true),
    "constant[lte]": checkFilterItem(history, "constant[lte]", null, true),
    "min[gte]": checkFilterItem(history, "min[gte]", null, true),
    "min[lte]": checkFilterItem(history, "min[lte]", null, true),
    "max[gte]": checkFilterItem(history, "max[gte]", null, true),
    "max[lte]": checkFilterItem(history, "max[lte]", null, true)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchFee = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/fees" + filterUrl + "&user.id=" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setFees(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchFee();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledFeeWrapper>
        <div className="content-head">
          <FeeFilter
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ItemsPerPageSelect
            itemsPerPage={filterData.itemsPerPage}
            setItemsPerPage={(data) => setFilterData({
              ...filterData,
              "itemsPerPage": data,
              page: 1
            })}
          />
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <FeeList
          fees={fees}
          fetchFees={fetchFee}
          notification={notification}
          setNotification={setNotification}
        />
        {totalPageCount > 1  &&
          <MaterialPagination
            count={totalPageCount}
            shape="rounded"
            page={filterData.page}
            onChange={(event, page) => onChangePage(event, page)}
          />}
      </StyledFeeWrapper>
    </>
  );
};

export default FeeContainer;